export default __webpack_public_path__ + "static/media/dashboard.db3994ee.svg";